window.Products.Embroidery = {};
window.Products.Embroidery.Embroidery = function(){};
window.Products.Embroidery.Embroidery.inherits(window.Products.Product);
window.Products.Embroidery.Embroidery.dpi = 150;
window.Products.Embroidery.Embroidery.has_3d = true;